import { FilterType, LeafFilterType, NodeFilterType } from './types'
import { LeafTypes, NodeType, QuestionType } from 'shared/types/ingestion'

export const duplicateSkillIdsFilter: LeafFilterType = {
  filterType: FilterType.leaf,
  typeSelections: {
    filterType: 'including',
    types: [LeafTypes.Skill, LeafTypes.WeightedSkill],
  },
  body: {
    skillID: { type: 'self', value: [] },
  },
}

export const duplicatePointsLeafFilter: LeafFilterType = {
  filterType: FilterType.leaf,
  typeSelections: {
    filterType: 'duplicateSibling',
    types: [LeafTypes.Points],
  },
}

export const allSkillLeaves: LeafFilterType = {
  filterType: FilterType.leaf,
  typeSelections: {
    filterType: 'including',
    types: [LeafTypes.Skill, LeafTypes.WeightedSkill],
  },
}

export const allQuestionsFilter: NodeFilterType = {
  filterType: FilterType.node,
  typeSelections: {
    filterType: 'including',
    types: [NodeType.Question],
  },
}

export const allWeightedSkillsList: NodeFilterType = {
  filterType: FilterType.node,
  typeSelections: {
    filterType: 'including',
    types: [NodeType.WeightedSkillsList],
  },
}

// Question type filter filters for questions that have a direct leaf
// descendant where the leaf has type `question` and value that is
// included in the passed in set
// If no question types to filter on then include all questions
export function getQuestionTypeFilter(...questionTypes: QuestionType[]) {
  if (!questionTypes.length) {
    return {
      ...allQuestionsFilter,
    }
  }
  const typeLeafFilter: LeafFilterType = {
    filterType: FilterType.leaf,
    typeSelections: {
      filterType: 'including',
      types: [LeafTypes.Question],
    },
    body: {
      value: {
        type: 'equal',
        value: questionTypes,
      },
    },
  }
  return {
    ...allQuestionsFilter,
    withDescendant: {
      directDescendant: true,
      mustIncludeAll: true,
      filter: [typeLeafFilter],
    },
  }
}
